export default Object.freeze({
  enEN: 'en-US',
  hrHR: 'hr-HR'
});